module.exports = "data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAACwBQCdASo8ADwAPpFCnUqlo6KhqhM4ALASCWUAzxqcyYDBAP0A9/8AUO6E4oxlsAU5iuJRbVwA/uJGv5v/9hbf+rtNbVQ7ayhE/IIu1eh+a0//6Ae/ngINXzHUmm1amZfKItFSIoeeLTJy0brbBB0gkAAAAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015-color.webp
// module id = T/cj
// module chunks = 14